import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/RecallsDashboard.css";
import { useHistory } from "react-router-dom";

const MESES = [
  "Enero", "Febrero", "Marzo", "Abril",
  "Mayo", "Junio", "Julio", "Agosto",
  "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export default function RecallsDashboard() {

    const hoy = new Date();
    const mesActual = hoy.getMonth() + 1;
    const mesSigActual = hoy.getMonth() + 2;
    const anioActual = hoy.getFullYear();

    const [year, setYear] = useState(anioActual);
    const [estadoMeses, setEstadoMeses] = useState({});
    const [mesSeleccionado, setMesSeleccionado] = useState(null);
    const [recalls, setRecalls] = useState([]);
    const [clinicaFiltro, setClinicaFiltro] = useState("ALL");
    const history = useHistory();

  // ===============================
  // Cargar estado de meses
  // ===============================
    const authConfig = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    };
    
    const cargarMeses = () => {
        axios.get(`/api/recalls/dashboard/${year}`, authConfig)
        .then(res => setEstadoMeses(res.data));
    };

    const formatearMotivo = (motivo) => {
        return motivo
            ?.toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, l => l.toUpperCase());
    };

    useEffect(() => {
        cargarMeses();
        setMesSeleccionado(null);
        setRecalls([]);
    }, [year]);

    // ===============================
    // Cargar recalls de un mes
    // ===============================
    const abrirMes = (mes) => {
        setClinicaFiltro("ALL");
        setMesSeleccionado(mes);
        axios.get(`/api/recalls/dashboard/${year}/${mes}`, authConfig)
        .then(res => setRecalls(res.data));
    };

    const ESTADOS = ["PENDIENTE", "REALIZADO", "CANCELADO"];

    const cambiarEstado = (recall) => {
        const index = ESTADOS.indexOf(recall.estado);
        const siguiente = ESTADOS[(index + 1) % ESTADOS.length];

        axios.put(
            `/api/recalls/${recall.id}/estado?estado=${siguiente}`,
            {},
            authConfig
        ).then(() => {
            setRecalls(prev =>
            prev.map(r =>
                r.id === recall.id ? { ...r, estado: siguiente } : r
            )
            );
        });
    };
    const siguienteMes = mesActual === 12 ? 1 : mesActual + 1;
    const anioSiguienteMes = mesActual === 12 ? anioActual + 1 : anioActual;

    const esMesEditable =
        (year === anioActual && mesSeleccionado === mesActual) ||
        (year === anioSiguienteMes && mesSeleccionado === siguienteMes);

    const recallsFiltrados =
        clinicaFiltro === "ALL"
            ? recalls
            : recalls.filter(r => r.clinica === clinicaFiltro);
    return (
        <div className="recalls-dashboard">

        {/* ================= CABECERA ================= */}
        <header className="recalls-header">
            <button onClick={() => setYear(y => y - 1)}>◀</button>
            <h2>Recalls · {year}</h2>
            <button onClick={() => setYear(y => y + 1)}>▶</button>
        </header>

        {/* ================= MESES ================= */}
        <section className="meses-grid">
            {MESES.map((nombre, i) => {
            const mes = i + 1;
            const tiene = estadoMeses[mes];

            return (
                <div
                key={mes}
                    className={`mes 
                    ${estadoMeses[mes] === "COMPLETO" ? "completo" : ""}
                    ${estadoMeses[mes] === "PENDIENTE" ? "activo" : ""}
                    ${estadoMeses[mes] === "VACIO" ? "vacio" : ""}
                    `}
                onClick={() => tiene && abrirMes(mes)}
                >
                {nombre}
                </div>
            );
            })}
        </section>

        {/* ================= LISTADO MES ================= */}
        {mesSeleccionado && (
            <section className="recalls-mes">

            <h3>
                {MESES[mesSeleccionado - 1]}
                {!esMesEditable && " (solo lectura)"}
            </h3>
            <div className="recalls-filtros">
                <button
                    className={clinicaFiltro === "ALL" ? "activo" : ""}
                    onClick={() => setClinicaFiltro("ALL")}
                >
                    Todas
                </button>

                <button
                    className={clinicaFiltro === "LA ELIPA" ? "activo" : ""}
                    onClick={() => setClinicaFiltro("LA ELIPA")}
                >
                    La Elipa
                </button>

                <button
                    className={clinicaFiltro === "VEN" ? "activo" : ""}
                    onClick={() => setClinicaFiltro("VEN")}
                >
                    VEN
                </button>
            </div>
            <table className={`recalls-table ${!esMesEditable ? "solo-lectura" : ""}`}>
                <thead>
                <tr>
                    <th>Clínica</th>
                    <th>Paciente</th>
                    <th>Fecha</th>
                    <th>Motivo</th>
                    <th>Comentario</th>
                    <th>Estado</th>
                    <th>Fecha recall</th>
                </tr>
                </thead>
                <tbody>
                {recallsFiltrados.map(r => (
                    <tr
                        key={r.id}
                        onDoubleClick={() =>
                            history.push(`/pacientes/${r.nExpediente}`)
                        }
                    >
                    <td>{r.clinica}</td>
                    <td>
                        <span
                            className="link-paciente"
                            onClick={() =>
                                history.push(
                                    `/pacientes/${r.nExpediente}`
                                )
                            }
                        >
                            {r.pacienteNombre}
                        </span>
                    </td>
                    <td>
                        {new Date(r.fechaRecall).toLocaleDateString("es-ES")}
                    </td>
                    <td>{formatearMotivo(r.motivo)}</td>
                    <td>{r.comentario}</td>
                    <td>
                        <span
                            className={`estado-badge estado-${r.estado.toLowerCase()}`}
                            onClick={() => esMesEditable && cambiarEstado(r)}
                        >
                            {formatearMotivo(r.estado)}
                        </span>
                    </td>
                    <td>
                        {r.fechaRealizado
                            ? new Date(r.fechaRealizado).toLocaleDateString("es-ES")
                            : "-"
                        }
                    </td>
                    </tr>
                ))}
                </tbody>
            </table>

            </section>
        )}

        </div>
    );
}
